import { NavItemBase } from "./types";

const home: NavItemBase = {
  label: "Home",
  iconName: "house"
};

const settings: NavItemBase = {
  label: "Settings",
  iconName: "cog"
};

const region: NavItemBase = {
  label: "Region",
  iconName: "globe"
};

const getPremium: NavItemBase = {
  label: "Get premium",
  iconName: "rocket"
};

const upgradePremium: NavItemBase = {
  label: "Upgrade",
  iconName: "rocket"
};

const classes: NavItemBase = {
  label: "Classes",
  iconName: "classes"
};

const courses: NavItemBase = {
  label: "Courses",
  iconName: "book"
};

const assignments: NavItemBase = {
  label: "Assignments",
  iconName: "books"
};

const bookTutor: NavItemBase = {
  label: "Book a 1:1 tutor",
  iconName: "classes"
};

const studentPlatform: NavItemBase = {
  label: "Student platform",
  iconName: "graduationCap"
};

const feedback: NavItemBase = {
  label: "Feedback",
  iconName: "megaphone"
};

const inviteParent: NavItemBase = {
  label: "Invite parent",
  iconName: "group"
};

const helpCentre: NavItemBase = {
  label: "Help centre",
  iconName: "help"
};

const mentalWellbeing: NavItemBase = {
  label: "Mental wellbeing",
  iconName: "heart"
};

const more: NavItemBase = {
  label: "More",
  iconName: "more"
};

const update: NavItemBase = {
  label: "Update app",
  iconName: "reassign"
};

const logOut: NavItemBase = {
  label: "Log out",
  iconName: "leave"
};

const darkMode: NavItemBase = {
  label: "Dark mode",
  iconName: "moon"
};

const NAV_ITEMS_BASE_COMMON = {
  home,
  settings,
  region,
  getPremium,
  upgradePremium,
  assignments,
  feedback,
  helpCentre,
  darkMode,
  update,
  logOut
};

export const NAV_ITEMS_BASE_STUDENT = {
  ...NAV_ITEMS_BASE_COMMON,
  courses,
  classes,
  inviteParent,
  mentalWellbeing,
  more
};

const NAV_ITEMS_BASE_PARENT = {
  ...NAV_ITEMS_BASE_COMMON,
  bookTutor,
  more
};

const NAV_ITEMS_BASE_TEACHER = {
  ...NAV_ITEMS_BASE_COMMON,
  studentPlatform,
  classes,
  assignments,
  inviteParent
};
